import BaseService from "./geral/BaseService";
import { objetoParaQueryString } from "../utils/formatar";

const base = "AtualizacaoCadastral";

export default class AtualizacaoCadastralService extends BaseService{
    
    constructor(props){
        super(props)
    }

    BuscarLogEmailFaturamento = (filtro) => {
        let str = objetoParaQueryString(filtro);
        return super.httpGet(`/${base}/BuscarLogEmailFaturamento?${str}`);
    }
    
    ListarClientes = (razaoOuCnpj) => {
        return super.httpGet(`/${base}/ListarClientes?razaooucnpj=${razaoOuCnpj}`);
    }

    ListarCnpjsPertentencesMesmoRadical = (cnpj) => {
        return super.httpGet(`/${base}/ListarCnpjMesmoRadical?cnpj=${cnpj}`);
    }

    ListarCategorias = () => {
        return super.httpGet(`/${base}/ListarCategorias`);
    }

    ListarGrupoEmail = (partnerId="",categoriaId="",clientId="") => {
        return super.httpGet(`/${base}/BuscarGrupoemail?partnerId=${partnerId}&CategoriaId=${categoriaId}&ClientId=${clientId}`);
    }
    ListarGrupoEmailId = (partnerId="",categoriaId="",clientId="") => {
        return super.httpGet(`/${base}/BuscarGrupoemailId?partnerId=${partnerId}&CategoriaId=${categoriaId}&ClientId=${clientId}`);
    }

    RemoverEmail = (email,aplicarRacical=false,listaClientes) => {
        return super.httpPost(`/${base}/ExcluirEmail?replicarMesmoRadical=${aplicarRacical}${listaClientes.map(cliente => `&listaClientes=${cliente.ClientId}`).join('')}`,email);
    }

    AdicionarEmail = (listaEmails,aplicarRacical=false, listaClientes) => {
        return super.httpPost(`/${base}/AdicionarEmail?replicarMesmoRadical=${aplicarRacical}${listaClientes.map(cliente => `&listaClientes=${cliente.ClientId}`).join('')}`,listaEmails);
    }
    
    GerarRelatorio = (parcId="", nomCliente="", dataBase="") => {
        return super.httpGet(`/${base}/GerarRelatorio?parcId=${parcId}&nomeCliente=${nomCliente}&dataBase=${dataBase}`);
    }

}



// WEBPACK FOOTER //
// ./src/services/AtualizacaoCadastralService.js